import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useSnackbar} from 'notistack';

import {topUpCfp, TopUpCfpParams} from '../api';
import {QUERY__USERS} from '../queryKeys';

export const useTopUpCfp = () => {
  const queryClient = useQueryClient();
  const {enqueueSnackbar} = useSnackbar();

  return useMutation({
    mutationFn: (params: TopUpCfpParams) => topUpCfp(params),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY__USERS],
      }),
    onError: error => {
      enqueueSnackbar(error.message, {
        variant: 'error',
      });
    },
  });
};
